import {Component, OnInit} from '@angular/core';
import {PostNumbers, TimetableTypes} from '../../constants';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../../helpers';
import {ActivatedRoute, Router} from '@angular/router';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {mergeMap} from 'rxjs/operators';

@Component({
  selector: 'app-timetable',
  templateUrl: './timetable.component.html',
  styleUrls: ['./timetable.component.scss']
})
export class TimetableComponent implements OnInit {

  public timetable: any;
  public contractorId = null;

  public timeTableTypes = Object.keys(TimetableTypes.types).map((key, index) => {
    return {
      label: TimetableTypes.types[key],
      value: key,
    };
  });

  public createNew = false;

  public form;
  public formSucces: string = null;
  public formError: string = null;
  public formProcessing = false;

  public loadingData = false;

  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
        title: this.fb.control('', Validators.required),
        email: this.fb.control(null, Validators.email),
        phoneNumber: this.fb.control(null),
        comments: this.fb.control(null),

        day0: this.fb.array([]),
        day1: this.fb.array([]),
        day2: this.fb.array([]),
        day3: this.fb.array([]),
        day4: this.fb.array([]),
        day5: this.fb.array([]),
        day6: this.fb.array([]),
      }
    );
  }

  ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      if (params.contractor) {
        this.contractorId = params.contractor;
        /*
        this.http.get(
          this.helper.getApiUrl('/timetable?timetable_mainContractor=' + params.contractor)).subscribe(
          (timetables) => {
            this.timetables = timetables;
          });
          */
      }
    });
    this.route.params.subscribe((params) => {
      if (params.timetable) {
        if (params.timetable === 'nov') {
          this.createNew = true;

          for (let i = 0; i < 7; i++) {
            const day = this.form.get('day' + i) as FormArray;
            this.addHours(i);
          }
        } else {
          this.loadingData = true;
          this.http.get(
            this.helper.getApiUrl('/timetable/' + params.timetable)).subscribe(
            (timetable) => {
              this.timetable = timetable;
              this.createForm();

              this.form.controls.title.setValue(this.timetable.title.raw);
              this.form.controls.email.setValue(this.timetable.acf.timetable_email);
              this.form.controls.phoneNumber.setValue(this.timetable.acf.timetable_phone);
              this.form.controls.comments.setValue(this.timetable.acf.timetable_comments);


              for (let i = 0; i < 7; i++) {
                const day = this.form.get('day' + i) as FormArray;

                if (!this.timetable.acf['timetable_day_' + (i + 1)]) {
                  this.timetable.acf['timetable_day_' + (i + 1)] = [];
                }

                if (this.timetable.acf['timetable_day_' + (i + 1)].length === 0) {
                  this.addHours(i);
                }
                this.timetable.acf['timetable_day_' + (i + 1)].forEach((tt) => {
                  day.push(
                    this.fb.group({
                      start: [tt['timetable_day_' + (i + 1) + '_start'],
                              Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)],
                      end: [tt['timetable_day_' + (i + 1) + '_end'],
                            Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)],
                    })
                  );
                });
              }
              this.loadingData = false;
            });
        }
      }
    });
  }

  addHours(dayIndex) {
    const day = this.form.get('day' + dayIndex) as FormArray;
    day.push(
      this.fb.group({
        start: ['', Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)],
        end: ['', Validators.pattern(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)],
      })
    );
  }

  removeHours(dayIndex, index) {
    const timetables = this.form.get('day' + dayIndex) as FormArray;
    timetables.removeAt(index);
  }

  update(form) {
    this.formSucces = null;
    this.formError = null;

    if (!this.form.valid) {
      this.formError = 'Preverite vpisane podatke.';
      return;
    }

    this.formProcessing = true;

    const data: any = {
      title: this.form.controls.title.value,
      fields: {
        timetable_phone: this.form.controls.phoneNumber.value,
        timetable_email: this.form.controls.email.value,
        timetable_comments: this.form.controls.comments.value,
        timetable_day_1: [],
        timetable_day_2: [],
        timetable_day_3: [],
        timetable_day_4: [],
        timetable_day_5: [],
        timetable_day_6: [],
        timetable_day_7: [],
      },
    };

    for (let i = 0; i < 7; i++) {
      const day = this.form.get('day' + i) as FormArray;

      day.controls.forEach((control, index) => {

        if (control.value.start !== '' || control.value.end !== '') {
          const newObj = {};
          newObj['timetable_day_' + (i + 1) + '_start'] = control.value.start;
          newObj['timetable_day_' + (i + 1) + '_end'] = control.value.end;

          data.fields['timetable_day_' + (i + 1)].push(newObj);
        } else {

        }
      });
      if (data.fields['timetable_day_' + (i + 1)].length === 0) {
        data.fields['timetable_day_' + (i + 1)] = false;
      }
    }

    if (this.createNew) {

      data.fields.timetable_mainContractor = this.contractorId;
      data.status = 'publish';

      this.http.post(this.helper.getApiUrl('/timetable'), data).subscribe(
        (unit: any) => {
          this.formProcessing = false;
          this.formSucces = 'Urnik je bil uspešno kreiran.';
          this.createNew = false;
          this.router.navigate(['ustanova', this.contractorId, 'urnik', unit.id], {queryParams: {}, replaceUrl: true});
        }, (error) => {
          this.formProcessing = false;
          this.formError = 'Pri shranjevanju podatkov je prišlo do napake.';
        });
    } else {
      this.http.put(this.helper.getApiUrl('/timetable/' + this.timetable.id), data).subscribe(
        (unit) => {
          this.formProcessing = false;
          this.formSucces = 'Podatki so bili uspešno shranjeni.';
        }, (error) => {
          this.formProcessing = false;
          this.formError = 'Pri shranjevanju podatkov je prišlo do napake.';
        });
    }
  }
}
